module.exports = __webpack_public_path__ + "img/courseList.70702761.svg";